<template>
  <Modal
    :id="'cmp-accounting-invoice-vat-territory-modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('please_select_vat_territory')}} </template>
    <template slot="body">
      <!-- <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr class="dt-table2--row">
            <th class="dt-table2--column">{{ $t("Territory Code") }}</th>
            <th class="dt-table2--column">{{ $t("Territory Name") }}</th>
            <th class="dt-table2--column">{{ $t("Vat Rate 1") }}</th>
            <th class="dt-table2--column">{{ $t("Vat Rate 2") }}</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
          <tr
            v-for="item in items"
            :key="item.vat_territory"
            class="dt-table2--row"
            @click="onItemClick(item)"
          >
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_territory }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_territory_name }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_rate1 }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_rate2 }}</span>
            </dt>
          </tr>
        </tbody>
      </table> -->
      <SearchList
        :id="'vvat_territory'"
        :items="items"
        :keyProperty="'vat_territory'"
        :label="'vat_territory_name'"
        :placeholder="'Search'"
        :selectionNumber="'single'"
        :isSearchable="false"
        :headers="[
          { text: 'Territory Code' },
          { text: 'Territory Name' },
          { text: 'Vat Rate 1' },
          { text: 'Vat Rate 2' },
        ]"
      >
        <template v-slot:item="{ item }">
          <tr class="dt-table2--row" @click="onItemClick(item)">
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_territory }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_territory_name }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_rate1 }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.vat_rate2 }}</span>
            </dt>
          </tr>
        </template>
      </SearchList>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
    </template>
  </Modal>
</template>
  
  <script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet } from "../../../../utility";
import { InvoicesService } from "../../services/invoices.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { format } from "date-fns";
import Modal from "@dtplugins/modal/modal";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: ["selectedInvoice"],
  data: function () {
    return {
      newData: {
        description: "",
        amount: "",
        external_id: 0,
      },
      vat_territories: [],
      releaseData: {},
      invoiceDateMenu: null,
      selectedReleases: new Set(),
    };
  },
  mounted: function () {
    this.findVatTerritories();
  },
  watch: {},
  computed: {
    items: function () {
      return this.vat_territories || [];
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },
    findVatTerritories() {
      InvoicesService.findVatTerritories(
        this.selectedInvoice?.invoice?.invoice_id
      ).then((res) => {
        this.vat_territories = res.data.vat_territories;
      });
    },

    onItemClick: function (item) {
      this.$emit("done", item);
    },
  },
};
</script>
  
  <style lang="scss">
.cmp-accounting-invoice-vat-territory-modal {
  .dt-table2 {
    --body-height: 200px !important;
    --row-margin-header:0px
  }
  padding: 40px 55px 30px !important;
  .amount-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .currency {
      position: absolute;
      right: 4px;
      text-align: center;
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
  .dt-input-box--container {
    flex: 1;
    margin: 2px 2px 12px 0px !important;
  }
}
</style>
  